export default __webpack_public_path__ + "static/media/phone_image.58cd3b53.png";